module.exports = __webpack_public_path__ + "49a3260b5f7f199c6a8b512ca6ecb81a.jpg";